"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsEvents_1 = require("./AnalyticsEvents");
var EventDecorators = /** @class */ (function () {
    function EventDecorators() {
    }
    EventDecorators.setReporter = function (rep) {
        this.reporter = rep;
        return this.reporter;
    };
    return EventDecorators;
}());
exports.EventDecorators = EventDecorators;
function sendEvent(eventType, props, pod, service, hostname, reporter) {
    if (props === void 0) { props = {}; }
    if (pod === void 0) { pod = "N/a"; }
    if (service === void 0) { service = "N/a"; }
    if (hostname === void 0) { hostname = window.location.hostname; }
    if (reporter === void 0) { reporter = EventDecorators.reporter; }
    if (reporter) {
        var eventFactory = new AnalyticsEvents_1.AnalyticsEventFactory(service, pod, hostname);
        var event_1 = eventFactory.createEventFromProps(eventType, props);
        reporter.reportEvent(event_1);
    }
    else {
        console.warn('Cannot send analytics event: no analytics reporter is configured.');
    }
}
exports.sendEvent = sendEvent;
function BasicEvent(eventType, props, pod, service, hostname, reporter) {
    return function () { return sendEvent(eventType, props, pod, service, hostname, reporter); };
}
exports.BasicEvent = BasicEvent;
// TODO: Are these functions actually being used? I didn't want to change the signature,
// but they seem like overkill to have in the library. This is where we might defer to the client
// to give their own decorators.
function UserActionEvent(eventType, action, invocationMethod, user, pod, service, hostname, reporter) {
    var props = { action: action, invocationMethod: invocationMethod };
    if (user) {
        props["user"] = user;
    }
    return BasicEvent(eventType, props, pod, service, hostname, reporter);
}
exports.UserActionEvent = UserActionEvent;
function FunnelEvent(eventType, phase, subphase, pod, service, hostname, reporter) {
    var props = { phase: phase, subphase: subphase };
    return BasicEvent(eventType, props, pod, service, hostname, reporter);
}
exports.FunnelEvent = FunnelEvent;
//# sourceMappingURL=EventDecorators.js.map